import { ApiError } from '@/core/services';
import { createSpcApi } from '@/core/utils';

import { CreateSpaceRes } from '@nest/shared';

import { useMutation } from '@tanstack/react-query';
import { FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSpaceReducer } from '../hooks/spaceReducer';
import { SpaceForm } from './SpaceForm';

export const CreateSpace = () => {
  const { state, dispatch } = useSpaceReducer();
  const nav = useNavigate();

  const createSpaceMutate = useMutation<CreateSpaceRes, ApiError>(createSpcApi(state), {
    onError: () => console.error('error'),
    onSuccess: data => {
      dispatch({ type: 'SET_NAME', payload: '' });
      dispatch({ type: 'SET_STATUS', payload: 'public' });
      dispatch({ type: 'SET_DESCRIPTION', payload: '' });
      nav(`/space/${data.space.id}`);
    },
  });

  const handleSubmit = (e: MouseEvent | FormEvent) => {
    e.preventDefault();
    createSpaceMutate.mutate();
  };

  return (
    <>
      {createSpaceMutate.isError && (
        <p className="mb-4 rounded-lg border border-red-200 bg-red-50 p-3 text-sm font-medium text-red-600 dark:border-red-900 dark:bg-red-900/20 dark:text-red-400">
          {createSpaceMutate.error.message}
        </p>
      )}
      <SpaceForm
        handleSubmit={handleSubmit}
        isLoading={createSpaceMutate.isLoading}
        dispatch={dispatch}
        state={state}
      />
    </>
  );
};
